export const REDUCER_USER_CHANGE_PASSWORD_NAME = 'userChangePasswordReducer';

export const CHANGE_PASSWORD_URL = '/user/profile/change-password';

export const CHANGE_PASSWORD_SUCCESS = 'CHANGE_PASSWORD_SUCCESS';

const USER_PROFILE_CHANGE_PASSWORD_URL = '/user/change-password';

export {
  USER_PROFILE_CHANGE_PASSWORD_URL,
};
